import { render, staticRenderFns } from "./LicenceCreation.vue?vue&type=template&id=7854d3c6&scoped=true&"
import script from "./LicenceCreation.vue?vue&type=script&lang=js&"
export * from "./LicenceCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854d3c6",
  null
  
)

export default component.exports